import { sidebar } from "./material-kit-pro-react";

const appStyle = theme => ({
    mainApp: {

    },
    mainAppResponsiv: {
        paddingTop: "0px",
        display: "flex",
        "& header": {
            boxShadow: "none",
            backgroundColor: "transparent"
        },
        "&.layout_page_help_about, &.layout_page_plans, &.layout_page_help, &.layout_page_privacy, &.layout_page_legal_terms, &.layout_page_contact": {
            "& .bg_slider": {
                display: "none !important"
            }
        },
    },
    backgroundOverlay: {
        "&:before": {
            content: '""',
            background: "linear-gradient(180deg, #0C101C 0%, #131725 100%)",
            width: "100%",
            height: "100%",
            position: "fixed",
            left: "0px",
            top: "0px",
            zIndex: "1"
        },
    },
    staticPage: {
        "& header": {
            backgroundColor: "rgba(0, 0, 0, 0.8)",
        }
    },
    bgSlider: {
        position: "fixed",
        left: "0px",
        zIndex: 0
    },
    sidebar: {
        ...sidebar(theme)
    },
    mainContent: {
        display: "flex",
        alignItems: "flex-start",
        "& .leftbar_content": {
            position: "relative",
            zIndex: "5",
            flexShrink: "0",
        },
        "& .rigth_content": {
            flex: "1",
            width: "calc(100% - 230px)"
        },
        [theme.breakpoints.down("sm")]: {
            display: "block",
            "& .rigth_content": {
                width: "100%"
            },
        }
    }
});

export default appStyle;